import { datadogRum } from '@datadog/browser-rum';
import { parse as parseArn } from '@aws-sdk/util-arn-parser';

import packageJson from '../../package.json';
import PrivacyService from 'services/PrivacyService';
import { getJourneyName } from 'utils/getSessionStoragePartner';

const {
  VITE_DATADOG_APP_SITE,
  VITE_DATADOG_APP_ID,
  VITE_DATADOG_APP_CLIENT_TOKEN,
  VITE_DATADOG_APP_SERVICE,
  VITE_STAGE,
  VITE_API_URL,
  VITE_PATH_PREFIX,
  VITE_AWS_ROLE
} = import.meta.env;

export const initDataDogRUM = async () => {
  /* istanbul ignore next -- @preserve */
  if (!VITE_DATADOG_APP_ID) {
    return;
  }

  try {
    await PrivacyService.init(async (privacy) => {
      const isDataDogAllowed =
        VITE_STAGE === 'local' || (await privacy.isDataDogAllowed());
      const isDataDogInitialized = !!datadogRum.getInitConfiguration();

      if (!isDataDogAllowed) {
        datadogRum.stopSessionReplayRecording();
        datadogRum.stopSession();
        return;
      }

      !isDataDogInitialized &&
        datadogRum.init({
          applicationId: VITE_DATADOG_APP_ID,
          clientToken: VITE_DATADOG_APP_CLIENT_TOKEN,
          service: VITE_DATADOG_APP_SERVICE,
          env: VITE_STAGE,
          version: packageJson.version,
          site: VITE_DATADOG_APP_SITE,
          sessionSampleRate: 100,
          sessionReplaySampleRate: 30,
          trackUserInteractions: true,
          defaultPrivacyLevel: 'mask-user-input',
          allowedTracingUrls: [VITE_API_URL],
          excludedActivityUrls: [
            (url) => !new RegExp(VITE_PATH_PREFIX).test(url)
          ],
          enablePrivacyForActionName: true,
          trackResources: true,
          trackLongTasks: true,
          enableExperimentalFeatures: ['clickmap', 'feature_flags'],
          beforeSend: (event) => {
            if (event.type === 'resource') {
              const match = event.resource.url.match(
                /\/premises\/([^/]+)\/services/
              );
              if (match) {
                event.context = { ...event.context, udprn: match[1] };
                event.resource.url = event.resource.url.replace(
                  /\/premises\/[^/]+\/services/,
                  '/premises/:udprn/services'
                );
              }
            }
            return true;
          }
        });

      datadogRum.startSessionReplayRecording();
      datadogRum.setGlobalContextProperty('journey', getJourneyName());
      datadogRum.setGlobalContextProperty('directorate', 'energy (nep)');
      datadogRum.setGlobalContextProperty('service', VITE_DATADOG_APP_SERVICE);

      /* istanbul ignore next -- @preserve */
      VITE_AWS_ROLE &&
        datadogRum.setGlobalContextProperty(
          'account',
          parseArn(VITE_AWS_ROLE)?.accountId
        );
    });
  } catch (e) {
    /* istanbul ignore next -- @preserve */
    console.error('Failed to initialize DataDog', e);
  }
};
